/**
 * Bridge between Auth0Provider and non-React code (serverRequest, history).
 * React components should use useAuth0 / withAuth0 from '@auth0/auth0-react' directly.
 * Initialized via setAuth0Context once the Auth0Provider has loaded.
 */
const auth0State = {
  isAuthenticated: false,
  user: null,
  getAccessTokenSilently: null,
  loginWithRedirect: null,
  logout: null,
};

/**
 * Set auth0 context
 *
 * @param {{}} auth0Context
 */
export function setAuth0Context({isAuthenticated, user, getAccessTokenSilently, loginWithRedirect, logout}) {
  auth0State.isAuthenticated = isAuthenticated;
  auth0State.user = user;
  auth0State.getAccessTokenSilently = getAccessTokenSilently;
  auth0State.loginWithRedirect = loginWithRedirect;
  auth0State.logout = logout;
}

const auth0 = {
  isAuthenticated: () => Promise.resolve(auth0State.isAuthenticated),
  getTokenSilently: () => auth0State.getAccessTokenSilently
    ? auth0State.getAccessTokenSilently()
    : Promise.reject(new Error('Auth0 not initialized')),
  getUser: () => Promise.resolve(auth0State.user),
  loginWithRedirect: (opts) => auth0State.loginWithRedirect && auth0State.loginWithRedirect(opts),
  logout: (opts) => auth0State.logout && auth0State.logout(opts),
};

export default auth0;
